import { render, staticRenderFns } from "./GlobalCustomCard.vue?vue&type=template&id=7f231c69&"
import script from "./GlobalCustomCard.vue?vue&type=script&lang=js&"
export * from "./GlobalCustomCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCustomCard.vue?vue&type=style&index=0&id=7f231c69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports